import { render, staticRenderFns } from "./FineDetail.vue?vue&type=template&id=18db9d02&scoped=true"
import script from "./FineDetail.vue?vue&type=script&lang=js"
export * from "./FineDetail.vue?vue&type=script&lang=js"
import style0 from "./FineDetail.vue?vue&type=style&index=0&id=18db9d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db9d02",
  null
  
)

export default component.exports